var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill:#E51058;\n;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M8,13.44c-.28,0-.5-.22-.5-.5V1.44c0-.28,.22-.5,.5-.5s.5,.22,.5,.5V12.94c0,.28-.22,.5-.5,.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14,15.94H2c-1.1,0-2-.9-2-2v-3c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v3c0,.55,.45,1,1,1H14c.55,0,1-.45,1-1v-3c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v3c0,1.1-.9,2-2,2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,5.44c-.14,0-.28-.06-.37-.17L8,1.2l-3.63,4.08c-.18,.21-.5,.23-.71,.04-.21-.18-.23-.5-.04-.71L7.48,.28c.27-.3,.78-.3,1.05,0l3.85,4.33c.18,.21,.16,.52-.04,.71-.09,.08-.21,.13-.33,.13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.42e83f899571257aedc89cf3980dc90d.svg";
export { ForwardRef as ReactComponent };